import { CHANGE_EMAIL_TOAST_KEY } from '../../types/toastTypes';
import { addToast } from './toastsActions';
export const CLEAR_REVERIFY_STATE = 'CLEAR_REVERIFY_STATE';
export const ASK_REVERIFY_EMAIL_ACCOUNT_FROM_INBOUND = 'ASK_REVERIFY_EMAIL_ACCOUNT_FROM_INBOUND';
export const SET_REVERIFY_PAGE = 'SET_REVERIFY_PAGE';
export const SET_IS_REVERIFY_ACTION_PENDING = 'SET_IS_REVERIFY_ACTION_PENDING';
export const SET_REVERIFY_NEW_EMAIL_VERIFICATION_SENT_FROM_INBOUND = 'SET_REVERIFY_NEW_EMAIL_VERIFICATION_SENT_FROM_INBOUND';
export function clearReverifyState() {
    return {
        type: CLEAR_REVERIFY_STATE
    };
}
export function askReverifyEmailAccountFromInbound(inbound) {
    return {
        type: ASK_REVERIFY_EMAIL_ACCOUNT_FROM_INBOUND,
        payload: inbound
    };
}
export function setReverifyPage(page) {
    return {
        type: SET_REVERIFY_PAGE,
        payload: page
    };
}
export function setIsReverifyActionPending(isActionPending) {
    return {
        type: SET_IS_REVERIFY_ACTION_PENDING,
        payload: isActionPending
    };
}
export function thunkUpdateReverifyEmailErrorFromInbound(inbound) {
    return function (dispatch) {
        dispatch(addToast({
            type: 'change-email-error',
            key: CHANGE_EMAIL_TOAST_KEY,
            message: inbound.error
        }));
        dispatch(setIsReverifyActionPending(false));
    };
}
export function setReverifyNewEmailVerificationSentFromInbound(inbound) {
    return {
        type: SET_REVERIFY_NEW_EMAIL_VERIFICATION_SENT_FROM_INBOUND,
        payload: inbound
    };
}
